module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f073d6_banner_800x600.97709732.png";